module.exports = __webpack_public_path__ + "img/full_logo.00312ce5.png";